<template>
  <div>
    <!-- CPF Input -->
    <div class="col form-group" v-if="!obj.passport">
      <input
        ref="cpfInput"
        id="cpf"
        v-model="obj.cpf"
        v-mask="'###.###.###-##'"
        class="w-100"
        :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
        :placeholder="CpfPlaceholder"
        style="margin-bottom: 30px"
        type="text"
        :disabled="disableCpfField"
      />
    </div>
    <!-- Phone Input -->
    <div class="col form-group">
      <input
        v-if="!obj.passport"
        ref="phoneInput"
        id="phone"
        v-model="obj.phone"
        v-mask="'(##) #####-####'"
        class="w-100"
        :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
        placeholder="Celular"
        type="tel"
        @keyup.enter="validateFields"
      />

      <!-- Phone Estrangeiro -->
      <div v-else class="phoneNumber">
        <div>
          <input
            list="countries"
            class="w-100 c-input"
            placeholder="DDI"
            id="phoneCodeInput"
            v-model="selectedPhoneCode"
            @keyup.enter="validateFields"
          />
          <datalist id="countries">
            <option
              class="text-black"
              v-for="(i, index) in countries"
              :value="'+' + i.phone_Code"
              :key="index"
            >
              {{ i.country_Name }}
            </option>
          </datalist>
        </div>
        <input
          v-model="phoneNumber"
          class="w-100"
          :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
          placeholder="Your phone"
          @keyup.enter="validateFields"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* State */
import { mapState, mapMutations } from 'vuex'

/* Helpers */
import { mask } from 'vue-the-mask'

export default {
  name: 'CpfAndPhone',
  mask: {
    ...mask,
    tokens: {
      ...mask.tokens,
      null: /./,
    },
  },
  props: {
    validate: {
      Boolean,
      required: true,
    },
  },
  data: () => ({
    obj: {},
    disableCpfField: false,
    selectedPhoneCode: '',
    phoneNumber: '',
  }),
  computed: {
    ...mapState(['config', 'registrationObject', 'subdomain', 'template', 'countries']),
    CpfPlaceholder() {
      return 'CPF'
    },
    phone() {
      return `${this.selectedPhoneCode} ${this.phoneNumber}`
    },
  },
  mounted() {
    // Create a deep copy of the object in the store
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))

    if (this.obj.cpf) {
      this.disableCpfField = true
    } else {
      document.getElementById('cpf').focus()
    }
  },
  methods: {
    ...mapMutations([
      'addRegistrationError',
      'clearRegistrationErrors',
      'updateRegistrationObject',
    ]),
    validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false

      if (this.obj.cpf && !this.checkCPF(this.obj.cpf)) {
        this.addRegistrationError({
          msg: 'Informe um CPF válido.',
        })

        hasErrors = true
      }

      if (!this.obj.phone) {
        this.addRegistrationError({
          msg: this.obj.passport
            ? 'It is necessary to provide a telephone number.'
            : 'É necessário informar um telefone.',
        })

        hasErrors = true
      }

      if (!this.obj.passport) {
        if (!this.validatePhone(this.obj.phone)) {
          this.addRegistrationError({
            msg: 'Informe um telefone válido.',
          })

          hasErrors = true
        }
      } else {
        if (!this.validateInternationalPhone(this.obj.phone)) {
          this.addRegistrationError({
            msg: 'Please provide a valid international telephone number.',
          })
          hasErrors = true
        }
      }

      if (!hasErrors) {
        this.$store.commit('updateRegistrationObject', this.obj)

        this.$emit('next')
      }
    },
    validatePhone(phone) {
      return phone.length === 15
    },
    validateInternationalPhone(phone) {
      var regex = /^[+]{1}(?:[0-9\-\\(\\)\\/.]\s?){6,15}[0-9]{1}$/
      return regex.test(phone)
    },
    checkCPF(value) {
      if (!value || !value.length) return false

      let cpf = value.replace(/[^\d]/g, '')

      if (
        cpf === '00000000000' ||
        cpf === '11111111111' ||
        cpf === '22222222222' ||
        cpf === '33333333333' ||
        cpf === '44444444444' ||
        cpf === '55555555555' ||
        cpf === '66666666666' ||
        cpf === '77777777777' ||
        cpf === '88888888888' ||
        cpf === '99999999999'
      ) {
        return false
      }

      let sum
      let remainder
      let i

      sum = 0

      for (i = 1; i <= 9; i++) {
        sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i)
      }

      remainder = (sum * 10) % 11

      if (remainder === 10 || remainder === 11) {
        remainder = 0
      }

      if (remainder !== parseInt(cpf.substring(9, 10))) {
        return false
      }

      sum = 0

      for (i = 1; i <= 10; i++) {
        sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i)
      }

      remainder = (sum * 10) % 11

      if (remainder === 10 || remainder === 11) {
        remainder = 0
      }

      if (remainder !== parseInt(cpf.substring(10, 11))) {
        return false
      }

      return true
    },
  },
  watch: {
    phone(newPhone) {
      this.obj.phone = newPhone
    },
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
}
</script>

<style>
.phoneNumber {
  display: flex;
  gap: 20px;
}
</style>
